import { TEditedData, TPaymentModel } from 'modules/settings/models';
import API from 'services/api';

export const updateContractPaymentModels = ({
  payload,
  paymentModelId,
}: {
  payload: TPaymentModel | TEditedData;
  paymentModelId: number;
}) => API.put(`/api/payment-models/${paymentModelId}`, payload);
